import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { mutateImageUrl } from '../../wordpress';
import TorsoTextOverlay from './TorsoTextOverlay';
import {
    selectSectionAndCategory,
    setActiveFilterButton,
    setCustomiseOverlayOpen,
    customiseProduct,
    setSearchOpen,
} from '../../actions';
import Warning from './Warning';
import { KEYCHAIN_PRODUCT_ID, isCreateYourOwnHeadProductId } from '../../constants';

const PreviewItem = ({
    item = null,
    info,
    dispatch,
    onRemove,
    isAccessoryItem = false,
    skintone = '',
    torsoOverlays = null,
    headFeatures = null,
    showBack = false,
    overrideImage = null,
    compositeDataUri = null,
    overlayImageSrc = null,
}) => {
    const [showWarning, setShowWarning] = useState(false);
    const accessoryNoItem = !item && isAccessoryItem;
    let imgSrc = info.defaultImage;

    if (item) {
        if (showBack && overrideImage) {
            imgSrc = mutateImageUrl(overrideImage, 480, 480);
        } else {
            // Prioritize composite image for bodies on front view
            if (info.id === 'bodies' && compositeDataUri) {
                imgSrc = compositeDataUri;
            } else if (item.attributes?.image?.url) {
                imgSrc = mutateImageUrl(item.attributes.image.url, 480, 480);
            } else if (item.productMatchAttr?.image?.url) {
                imgSrc = item.productMatchAttr?.image?.url;
            } else if (item.product?.featuredImage?.url) {
                imgSrc = item.product.featuredImage.url;
            }
        }
    }

    const facialFeaturesHandle = headFeatures?.facialFeaturesHandle || '';
    const facialFeaturesClassName =
        /freckle/i.test(facialFeaturesHandle) && !/lipstick|kisses?/i.test(facialFeaturesHandle)
            ? 'preview-item__image overlay overlay-head--facialFeatures overlay-head--facialFeatures-underHair'
            : 'preview-item__image overlay overlay-head--facialFeatures';

    return (
        <>
            <div
                className={`preview-item preview-item__${info.id} ${accessoryNoItem ? 'show-border' : ''} ${
                    !isAccessoryItem ? 'not-accessory' : ''
                } ${item ? 'has-item' : ''}`}
            >
                <button
                    className={`preview-item__button preview-item__button--item ${accessoryNoItem ? 'vh' : ''}`}
                    onClick={() => {
                        const isKeychain = info.id === 'keychain';
                        dispatch(setSearchOpen(false));
                        if (isKeychain) {
                            if (item?.product) {
                                dispatch(setCustomiseOverlayOpen(true));
                                dispatch(customiseProduct(item.product));
                                return;
                            }
                            const displayInfo = { ...info, id: 'display' };
                            dispatch(selectSectionAndCategory(displayInfo, null, skintone));
                            dispatch(setActiveFilterButton(null));
                            dispatch(setCustomiseOverlayOpen(true));
                            dispatch(customiseProduct({ id: KEYCHAIN_PRODUCT_ID }));
                            return;
                        }
                        const theInfo = { ...info };
                        if (theInfo.id.startsWith('accessories:')) {
                            theInfo.id = 'accessories';
                        }
                        dispatch(selectSectionAndCategory(theInfo, null, skintone));
                        dispatch(setActiveFilterButton(null));
                    }}
                >
                    {imgSrc && <img className="preview-item__image" src={imgSrc} alt="" />}
                    {info.id === 'display' && item && !showBack && overlayImageSrc && (
                        <img
                            className="preview-item__image overlay displayUploadCompositeImage"
                            src={overlayImageSrc}
                            alt=""
                        />
                    )}
                    {info.id === 'bodies' && (
                        <>
                            <TorsoTextOverlay
                                minFontSize={5}
                                showBackText={showBack}
                                productTags={item?.product?.tags}
                                product={item?.product}
                            />
                            {torsoOverlays && !showBack && (
                                <>
                                    {torsoOverlays.handImage && (
                                        <img
                                            className="preview-item__image overlay handImage"
                                            src={torsoOverlays.handImage}
                                            alt=""
                                        />
                                    )}
                                    {item && torsoOverlays.torsoOverlayImage && !compositeDataUri && (
                                        <img
                                            className="preview-item__image overlay torsoOverlayImage"
                                            src={torsoOverlays.torsoOverlayImage}
                                            alt=""
                                        />
                                    )}
                                </>
                            )}
                        </>
                    )}
                    {info.id === 'heads' &&
                        headFeatures &&
                        item &&
                        !showBack &&
                        isCreateYourOwnHeadProductId(item.product?.id) && (
                            <>
                                {headFeatures.eyebrows && (
                                    <img
                                        className="preview-item__image overlay overlay-head--eyebrows"
                                        src={headFeatures.eyebrows}
                                        alt=""
                                    />
                                )}
                                {headFeatures.eyes && (
                                    <img
                                        className="preview-item__image overlay overlay-head--eyes"
                                        src={headFeatures.eyes}
                                        alt=""
                                    />
                                )}
                                {headFeatures.mouth && (
                                    <img
                                        className="preview-item__image overlay overlay-head--mouth"
                                        src={headFeatures.mouth}
                                        alt=""
                                    />
                                )}
                                {headFeatures.facialHair?.styleImageUrl && (
                                    <img
                                        className={`preview-item__image overlay overlay-head--${headFeatures.facialHair.type}`}
                                        src={headFeatures.facialHair.styleImageUrl}
                                        alt=""
                                    />
                                )}
                                {headFeatures.glasses && (
                                    <img
                                        className="preview-item__image overlay overlay-head--glasses"
                                        src={headFeatures.glasses}
                                        alt=""
                                    />
                                )}
                                {headFeatures.facialFeatures && (
                                    <img className={facialFeaturesClassName} src={headFeatures.facialFeatures} alt="" />
                                )}
                            </>
                        )}
                </button>

                {/*
                <div className="preview-item__button--container">
                     <button
                        type="button"
                        className={`preview-item__button ${
                            item ? 'preview-item__button--edit' : 'preview-item__button--add'
                        }`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (item) {
                                onEdit(info.id, item.product.id);
                                dispatch(setActiveFilterButton(null));
                            } else {
                                dispatch(selectSectionAndCategory(info, null, skintone));
                                dispatch(setActiveFilterButton(null));
                            }

                            const browser = document.querySelector('.browser');
                            browser?.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >
                        Edit
                    </button> 
                */}

                {/*
                    <div className="preview-item__button--container remove">
                        <button
                            type="button"
                            className={`preview-item__button preview-item__button--remove ${
                                item ? '' : 'preview-item__button--vh'
                            } ${accessoryNoItem ? 'vh' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowWarning(true);
                            }}
                        >
                            Remove
                        </button>
                    </div>
                */}
            </div>

            {showWarning && (
                <Warning
                    actionConfirm={() => {
                        setShowWarning(false);
                        onRemove(info.id);
                    }}
                    actionDeny={() => {
                        setShowWarning(false);
                    }}
                    warningText="Are you sure that you'd like to remove this item?"
                />
            )}
        </>
    );
};

export default PreviewItem;

const imageEdgeShape = PropTypes.shape({
    node: PropTypes.shape({
        url: PropTypes.string,
    }),
});

const productShape = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    featuredImage: PropTypes.shape({
        url: PropTypes.string,
    }),
    images: PropTypes.shape({
        edges: PropTypes.arrayOf(imageEdgeShape),
    }),
    tags: PropTypes.arrayOf(PropTypes.string),
    variants: PropTypes.shape({
        nodes: PropTypes.array,
        edges: PropTypes.array,
    }),
});

const valueShape = PropTypes.shape({ value: PropTypes.string });

const selectedItemShape = PropTypes.shape({
    product: productShape,
    attributes: PropTypes.shape({
        image: PropTypes.shape({ url: PropTypes.string }),
        title: PropTypes.string,
        torsoOverlayValue: valueShape,
        skintoneValue: valueShape,
    }),
    productMatchAttr: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        image: PropTypes.shape({ url: PropTypes.string }),
        reverseImage: PropTypes.shape({
            reference: PropTypes.shape({
                image: PropTypes.shape({ url: PropTypes.string }),
            }),
        }),
        skintoneValue: valueShape,
    }),
    category: PropTypes.any,
});

const torsoOverlaysShape = PropTypes.shape({
    handImage: PropTypes.string,
    torsoOverlayImage: PropTypes.string,
});

PreviewItem.propTypes = {
    item: selectedItemShape,
    info: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
        emptyText: PropTypes.string,
        defaultImage: PropTypes.string,
        handle: PropTypes.string,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    isAccessoryItem: PropTypes.bool,
    skintone: PropTypes.string,
    torsoOverlays: torsoOverlaysShape,
    headFeatures: PropTypes.shape({
        eyebrows: PropTypes.string,
        eyes: PropTypes.string,
        mouth: PropTypes.string,
        facialHair: PropTypes.shape({
            type: PropTypes.string,
            style: PropTypes.string,
            styleImageUrl: PropTypes.string,
        }),
        glasses: PropTypes.string,
        facialFeatures: PropTypes.string,
        facialFeaturesHandle: PropTypes.string,
    }),
    showBack: PropTypes.bool,
    overrideImage: PropTypes.string,
    compositeDataUri: PropTypes.string,
    overlayImageSrc: PropTypes.string,
};
